import { updateIntl } from 'react-intl-redux';
import { connect } from 'react-redux';

import View from './';

const mapStateToProps = state => ({ intl: state.intl });

const mapDispatchToProps = {
  changeLanguage: updateIntl,
};

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./js/views/quote-view/container.js